// react
import React, { useState, useEffect, useCallback } from "react";

// third-party
import classNames from "classnames";
import { Link } from "react-router-dom";
import { getNoImg, url, returnResponsiveImg, useWindowSize, allEqual, compareProductIsSame, checkHvStock } from "../../services/utils";
import { Check9x7Svg } from "../../svg";
import Currency from "../shared/Currency";
import InputNumber from "../shared/InputNumber";
import ReactAwesomePopover from "react-awesome-popover";
import { cartAddItem } from "../../store/cart";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Drawer from "react-bottom-drawer";
const Popover = ReactAwesomePopover;

function BlockProductAddOnDeals(props) {
    const { product, eventData, history, noTitle } = props;
    const [addOnDeals, setAddOnDeals] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [showPopBoxBySlug, setShowPopBoxBySlug] = useState(null);
    const [addCartLoading, setAddCartLoading] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [totalPrice, setTotalPrice] = useState(0);
    const [oriTotalPrice, setOriTotalPrice] = useState(0);
    const windowSize = useWindowSize();
    const dispatch = useDispatch();
    const cart = useSelector((state) => state?.cart);

    useEffect(() => {
        let list = [];
        let mainProd = [];

        if (
            eventData?.event_info &&
            product.status?.code == 10 &&
            checkHvStock(product) &&
            (product.progression == "ongoing" || product.progression == null)
        ) {
            let maximumNumber = eventData?.event_info?.condition_json?.max_sum_sub_item_qty;
            let addOnList = eventData?.event_info?.joined_product_json.find((item) => item.slug == product.slug);
            if (addOnList) {
                addOnList.sub_prod.slice(0, 4).forEach((item, index) => {
                    //only show hv stock & available add to cart product
                    if (item.status?.code == 10 && checkHvStock(item) && (item.progression == "ongoing" || item.progression == null) && !item.enquiry_only) {
                        item.selectedVariant = item.variant_choices.find((opt) => opt.stock_count > 0);
                        item.qty = 1;
                        item.selected = index < maximumNumber ? true : false;
                        list.push(item);
                    }
                });
                mainProd = addOnList;
                mainProd.selected = true;
                mainProd.selectedVariant = mainProd.variant_choices.find((opt) => opt.stock_count > 0);
                mainProd.qty = 1;

                if (list.length > 0) {
                    list.unshift(mainProd);
                }
                setAddOnDeals(list);
            }
        }
    }, [eventData, product]);

    useEffect(() => {
        let total = 0,
            oriTotal = 0;
        addOnDeals
            .filter((item) => item.selected == true)
            .forEach((item) => {
                oriTotal += parseFloat(item.selectedVariant.retail_price) * item.qty;
                total += parseFloat(item.selectedVariant.offer_price) * item.qty;
            });
        setOriTotalPrice(parseFloat(oriTotal).toFixed(2));
        setTotalPrice(parseFloat(total).toFixed(2));
    }, [addOnDeals]);

    const returnResponsiveItemCount = () => {
        return windowSize.width < 576 ? 1 : windowSize.width < 768 ? 2 : windowSize.width < 992 ? 3 : 4;
    };

    const hvStock = (prod, variantID, order) => {
        if (selectedOption || order == 0) {
            let currentVariantOrder = order == 1 ? 0 : 1;

            let matchCombinations = prod.variant_choices.find((item) => {
                return (
                    item.combinations[order]?.uuid == variantID &&
                    item.combinations[currentVariantOrder]?.uuid == selectedOption?.combinations[currentVariantOrder].uuid
                );
            });
            if (matchCombinations) {
                if (matchCombinations.stock_count == 0) return false;
            }
            return true;
        } else {
            return true;
        }
    };

    const addDealsToCart = async () => {
        let totalQty = 0;

        let maximumNumber = eventData?.event_info?.condition_json?.max_sum_sub_item_qty;
        addOnDeals
            .filter((item) => item.selected == true)
            .slice(1, returnResponsiveItemCount() + 1)
            .forEach((item) => {
                totalQty += item.qty;
            });

        let mainProdInCart = cart.items.find((item) => {
            return compareProductIsSame(item, addOnDeals[0]);
        });

        if (mainProdInCart && mainProdInCart.subProds) {
            mainProdInCart.subProds.forEach((item) => {
                totalQty += item.quantity;
            });
        }

        if (totalQty <= maximumNumber) {
            setAddCartLoading(true);

            let cartList = await dispatch(cartAddItem(addOnDeals[0], addOnDeals[0].selectedVariant.uuid, [], addOnDeals[0].qty)).catch(
                (err) => {
                    setAddCartLoading(false);
                }
            );
            cartList.filter((item) => {
                return item.product.uuid == addOnDeals[0].uuid;
            });
            let cartMainProd = cartList.find((item) => {
                return compareProductIsSame(item, addOnDeals[0]);
            });

            await addOnDeals
                .slice(1, returnResponsiveItemCount() + 1)
                .filter((item) => item.selected == true)
                .forEach((item) => {
                    dispatch(
                        cartAddItem(item, item.selectedVariant.uuid, [], item.qty, {
                            uuid: eventData.uuid,
                            parentHash: cartMainProd.hash,
                        })
                    );
                });
            setAddCartLoading(false);
            toast.success("Add-on deals added to cart", {
                autoClose: 3000,
                onClick: () => {
                    history.push("/cart");
                },
            });
        } else {
            toast.error("You can only select up to " + maximumNumber + " items.");
        }
    };

    const renderVariant = (prod, index, item) => {
        return (
            <div key={item.uuid} className="form-group product__option">
                <div className="product__option-label">{item?.name}</div>

                <div className="variant-box__list">
                    {item?.options.map((opt, number) => {
                        let hasStock = hvStock(prod, opt.uuid, index);

                        return (
                            <label
                                key={opt.uuid}
                                onClick={() => {
                                    let anotherOrder = index == 1 ? 0 : 1;
                                    if (hasStock) {
                                        setSelectedOption(
                                            prod?.variant_choices.find((variant) => {
                                                return variant.combinations.length > 1
                                                    ? variant.combinations[index]?.uuid == opt.uuid &&
                                                          variant.combinations[anotherOrder]?.uuid ==
                                                              selectedOption.combinations[anotherOrder].uuid
                                                    : variant.combinations.find((combi) => combi.uuid == opt.uuid);
                                            })
                                        );
                                    }
                                }}
                                className={
                                    "variant-box " +
                                    (hasStock
                                        ? selectedOption?.combinations.find((variant) => variant.uuid == opt.uuid)
                                            ? "active"
                                            : ""
                                        : "disabled")
                                }
                            >
                                <div>{opt.name}</div>
                                <div className="selected-triangle" />
                            </label>
                        );
                    })}
                </div>
            </div>
        );
    };

    const confirmChangeVariant = (product, index) => {
        let list = [];
        addOnDeals.forEach((item, itemIndex) => {
            if (itemIndex + "/" + item.slug == index + "/" + product.slug) {
                if (selectedOption) item.selectedVariant = selectedOption;
                item.qty = quantity;
            }
            list.push(item);
        });

        setAddOnDeals(list);
        setSelectedOption(null);
        setShowPopBoxBySlug(null);
    };

    const handleSelectedChange = (slug) => {
        let list = [];
        addOnDeals.slice(1, addOnDeals.length).forEach((item) => {
            if (item.slug == slug) {
                item.selected = !item.selected;
            }
            list.push(item);
        });
        list.unshift(addOnDeals[0]);
        setAddOnDeals(list);
    };

    const resetPopProductWhenClose = useCallback(() => {
        setSelectedOption(null);
        setQuantity(1);
        setShowPopBoxBySlug(null);
    }, []);

    const selectVariantComponent = (prod, index) => {
        return (
            <div className="variant-popover-box">
                {prod.variant_info?.length == 1 && prod.variant_info[0]?.options.length == 1
                    ? null
                    : prod?.variant_info?.map((item, optIndex) => {
                          return renderVariant(prod, optIndex, item, selectedOption);
                      })}

                <div>
                    Quantity
                    <InputNumber
                        id="add-on-deals-quantity"
                        aria-label="Quantity"
                        className="product__quantity"
                        size={"md"}
                        min={1}
                        max={prod.selectedVariant.stock_count}
                        value={quantity}
                        onChange={(value) => setQuantity(value)}
                    />
                </div>
                <div className="d-flex justify-content-end mt-2">
                    <button className="btn btn-sm btn-secondary mr-2" onClick={() => setShowPopBoxBySlug(null)}>
                        Cancel
                    </button>

                    <button
                        className="btn btn-sm btn-primary"
                        onClick={() => {
                            confirmChangeVariant(prod, index);
                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        );
    };

    const renderSelectedVariant = (prod, isMainProd, index) => {
        let selectedVariant = prod.selectedVariant;

        let renderSelectedOption = (
            <div
                onClick={() => {
                    setSelectedOption(selectedVariant);
                    setShowPopBoxBySlug(index + "/" + prod.slug);
                }}
                className="c-pointer d-flex"
            >
                {selectedVariant.combinations.map((combi, index) => {
                    return prod.variant_choices?.length > 1 ? (
                        <>
                            {combi.name}
                            {index == selectedVariant.combinations.length - 1 ? null : ","}
                        </>
                    ) : (
                        <div key={index} className="text-muted">
                            Select variation
                        </div>
                    );
                })}
                <i className="fas fa-sort-down ml-1 mr-2" />
            </div>
        );

        let prices = (
            <>
                <span className="product__new-price">
                    <Currency value={selectedVariant.offer_price} />
                </span>
                {!allEqual([selectedVariant.offer_price, selectedVariant.retail_price], "price") ? (
                    <>
                        <span className="product__old-price">
                            <Currency value={selectedVariant.retail_price} />
                        </span>
                    </>
                ) : null}
            </>
        );
        return (
            <div className="product-variant-info">
                <div className="d-flex">
                    <span className="input-check__body mr-2">
                        <input
                            className="input-check__input"
                            type="checkbox"
                            disabled={isMainProd ? true : false}
                            defaultChecked={prod.selected}
                            onChange={() => handleSelectedChange(prod.slug)}
                        />
                        <span className="input-check__box" />
                        <Check9x7Svg className="input-check__icon" />
                    </span>
                    {windowSize.width < 768 ? (
                        <>
                            {renderSelectedOption}
                            <Drawer isVisible={index + "/" + prod.slug == showPopBoxBySlug} onClose={resetPopProductWhenClose}>
                                {selectVariantComponent(prod, index)}
                            </Drawer>
                        </>
                    ) : (
                        <Popover
                            action="click"
                            preventDefault
                            overlayColor={"rgba(0,0,0,0.1)"}
                            open={index + "/" + prod.slug == showPopBoxBySlug}
                            onClose={resetPopProductWhenClose}
                        >
                            {renderSelectedOption}
                            {selectVariantComponent(prod, index)}
                        </Popover>
                    )}
                </div>

                {prices}
            </div>
        );
    };

    const renderProduct = (prod, isMainProd, index) => {
        return (
            <div key={prod.slug} className="product-bundle-card">
                <div className="product-card__image product-image">
                    <Link to={url.product(prod)} className="product-image__body">
                        <img
                            className="product-image__img"
                            src={prod.images && prod.images[0] ? returnResponsiveImg(prod.images[0]) : getNoImg()}
                            alt=""
                            onError={(e) => (e.target.src = getNoImg())}
                        />
                        {prod.qty > 1 ? <span className="right-bottom-qty">{prod.qty}</span> : null}
                    </Link>
                </div>
                <div className="product-bundle-card__info">
                    <div className={"product-card__name"}>
                        <Link to={url.product(prod)}>
                            {isMainProd ? null : <label className="outline-label">Add On</label>}
                            {prod.name}
                        </Link>
                    </div>
                    {renderSelectedVariant(prod, isMainProd, index)}
                </div>
            </div>
        );
    };

    return addOnDeals?.length > 0 ? (
        <div className="bundle-deals-section">
            <div className="addon-section">
                <div className="section-title">
                    <div style={noTitle ? { visibility: "hidden" } : {}}>Add-on Deals</div>
                    <Link to={{ pathname: url.addOnDeals(product) }} className="more">
                        View More <i className="fas fa-chevron-right" />
                    </Link>
                </div>
                <div className="product-bundle-list">
                    {addOnDeals[0] && addOnDeals[0].selectedVariant ? renderProduct(addOnDeals[0], true, 0) : null}
                    <i className="fa fa-plus" aria-hidden="true"></i>
                    {addOnDeals[1] &&
                        addOnDeals[1].selectedVariant &&
                        addOnDeals?.slice(1, returnResponsiveItemCount() + 1).map((item, index) => {
                            return renderProduct(item, false, index + 1);
                        })}
                </div>
            </div>
            <div className="bundle-total">
                <div>
                    Total :
                    <>
                        <span className="product__new-price">
                            <Currency value={totalPrice} />
                        </span>
                        <span className="product__old-price">
                            <Currency value={oriTotalPrice} />
                        </span>
                    </>
                </div>
                {oriTotalPrice - totalPrice > 0 ? (
                    <div className="text-color-theme">
                        Savings <Currency value={oriTotalPrice - totalPrice} />
                    </div>
                ) : null}

                <button
                    type="button"
                    onClick={() => addDealsToCart()}
                    className={classNames("mt-lg-2 btn btn-primary btn-sm", {
                        "btn-loading": addCartLoading,
                    })}
                >
                    Add to Cart
                </button>
            </div>
        </div>
    ) : null;
}

export default BlockProductAddOnDeals;
